import type { AdminPaymentItem } from './adminPayment';

export type InstapayReviewStatus = 'pending_review' | 'approved' | 'rejected' | 'temp_expired';

export interface AdminInstapayReviewItem extends AdminPaymentItem {
  payment_status: InstapayReviewStatus | string;
  receipt_file_name: string | null;
  receipt_mime_type: string | null;
  receipt_size_bytes: number | null;
  receipt_preview_url: string | null;
  temporary_access_granted_at: string | null;
  temporary_access_expires_at: string | null;
  temporary_access_active: boolean;
  temporary_access_remaining_seconds: number | null;
  reviewed_at: string | null;
  reviewed_by: string | null;
  rejection_reason: string | null;
  review_version: number;
  reviewable: boolean;
}

export interface AdminInstapayReviewsListResponse {
  items: AdminInstapayReviewItem[];
  next_cursor: string | null;
  total: number;
}

export interface ListAdminInstapayReviewsQuery {
  status?: InstapayReviewStatus;
  tenant_id?: string;
  product_id?: string;
  product_slug?: string;
  plan_id?: string;
  search?: string;
  from?: string;
  to?: string;
  cursor?: string;
  limit?: number;
}

export const INSTAPAY_REVIEW_STATUS_OPTIONS: InstapayReviewStatus[] = [
  'pending_review',
  'temp_expired',
  'approved',
  'rejected',
];

export interface ReviewInstapayPaymentBody {
  reason: string;
  version: number;
}
